
/* Common: ADI Utils */
ADILF.define('adilf/util/utils',['streamhub-sdk/jquery', 'adilf/context'], function(jquery, Context) {
    "use strict";

    return {

        isMobile: function() {
            /* istanbul ignore next */
            return !!(window.Modernizr && window.Modernizr.touch && document.documentElement.clientWidth <= 640);
        },

        /* istanbul ignore next */
        scroll2position: function(scrollPos) {
            if(!!isNaN(parseInt(scrollPos))) { return; }
            if(jquery(window).scrollTop() !== scrollPos) {
              jquery('html, body').animate({
                  scrollTop: scrollPos
              }, 300);
            }
        },

        modifyCSSClass: function(classLabel, className, classValue) {
            if(!(classLabel && className && classValue)) { return; }
            var cssMainContainer = jquery('#css-modifier-container');
            if (cssMainContainer.length === 0) {
                cssMainContainer = jquery('<div id="css-modifier-container"></div>');
                cssMainContainer.hide();
                cssMainContainer.appendTo(jquery('body'));
            }
            var classContainer = cssMainContainer.find('div[data-class="' + classLabel + '"]');
            if (classContainer.length === 0) {
                classContainer = jquery('<div data-class="' + classLabel + '"></div>');
                classContainer.appendTo(cssMainContainer);
            }
            classContainer.html('<style>' + className + ' {' + classValue + '}</style>');
            return true;
        },

        smartTruncate: function(str, limit) { // limit in chars
            var truncated = false;
            limit = limit || 100;
            var strArr = (str).length < limit ? str.split(" ") : ((str).substring(0, limit-1)).split(" ");
            if((str).length >= limit) { truncated = true; strArr.pop(); } // remove potentially truncated word
            return (strArr).join(" ") + (function(){return (truncated) ? "..." : "";})();
        },

        translateProfileUrl: function(url) {
            return url.replace(/advance.net/, Context.getAffiliate().domain);
        },

        livefyreSafeUIDEncode: function(UID) {
            if (UID.match(/[^a-zA-Z0-9_-]/)) {
                UID = 'LFT_' + btoa(UID).replace(/=/g, '_');
            }
            return UID;
        },

        livefyreSafeUIDDecode: function(UID) {
            if (UID.substr(0, 4) === 'LFT_') {
                UID = atob(UID.substr(4, UID.length - 1).replace(/_/g, '='));
            }
            return UID;
        }

    };
});